import clsx from 'clsx';
import React from 'react';
import styles from './IconButton.module.scss';
import { AudioManager, AudioType } from '@colonist/audio';
import { Image } from '../Image/index.ts';
export const IconButton = ({ icon, alt, inverted = false, onClick, className, iconClassName, ...props })=>{
    return /*#__PURE__*/ React.createElement("button", {
        type: "button",
        className: clsx(styles.iconButton, {
            [styles.inverted]: inverted
        }, className),
        onClick: (event)=>{
            AudioManager.play(AudioType.Click);
            onClick === null || onClick === void 0 ? void 0 : onClick(event);
        },
        ...props
    }, /*#__PURE__*/ React.createElement(Image, {
        className: clsx(styles.icon, iconClassName),
        image: {
            src: icon,
            alt: alt
        }
    }));
};
